import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import {
  __,
  getActiveStage,
  getURLParam,
  redirect,
  setTableParams,
  setURLParam,
  sortValuesByArray,
} from '../../core/utils';
import styles from '../../styles/views/plans/PlanVersionPreview.scss';
import {
  filterPlanVersionAnnotations,
  listComparablePlanVersions,
  listPinnedPlanVersionSpecifications,
  listPlanVersionPlans,
  listPlanVersionTasks,
  parsePlanPdfToJson,
  readPlanVersion,
  readPlanVersionAnotation,
  readWorkingSetPlan,
  retilePlanVersion,
  searchPdfTextPositions,
  updatePlanVersionAnotation,
} from '../../redux/actions/table/working_set_plans';
import ArrowLeftMiddleIcon from '../../assets/images/arrow-left-middle-15x15.svg';
import ArrowRightSmallIcon from '../../assets/images/arrow-right-small-15x15.svg';
import queryString from 'query-string';
import { connect } from 'react-redux';
import classNames from 'classnames';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import CompareIcon from '../../assets/images/compare-15x15.svg';

import Tooltip from '../../components/Tooltip';

// NEW
import Localization from '../../helpers/Localization';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';

import {
  findTaskObjectOnCanvas,
  resetObjectStyle,
  selectObjectStyle,
} from '../../components/CanvasEditor/helpers/fabricHelpers';

import { readTask } from '../../redux/actions/table/all_tasks';
import TasksFlyout from '../../flyouts/tasks/TasksFlyout';
import WorkingSetPlansFlyout from '../../flyouts/working_set_plans/WorkingSetPlansFlyout';
import { getStatusColor } from '../../components/CanvasEditor/components/Task/taskStatusColors';
import TitleBar from '../../containers/TitleBar';
import ArrowDoubleLeftMiddleIcon from '../../assets/images/arrow-double-left-middle-15x15.svg';
import ArrowRightMiddleIcon from '../../assets/images/arrow-right-middle-15x15.svg';
import ArrowDoubleRightMiddleIcon from '../../assets/images/arrow-double-right-middle-15x15.svg';
import ReactDOM from 'react-dom';
import FilterIcon from '../../assets/images/filter-15x15.svg';
import Filter from '../../components/CanvasEditor/components/Filter/Filter';
import { getPreferences } from '../../redux/actions/profile';
import { isSafari } from 'react-device-detect';
import ComparePlans from './components/ComparePlans/ComparePlans';
import { readWorkingSetSpecification } from '../../redux/actions/table/working_set_specifications';
import WorkingSetSpecificationsFlyout from '../../flyouts/working_set_specifications/WorkingSetSpecificationsFlyout';
import SearchInline from '../../components/CanvasEditor/components/Search/SearchInline';
import { setNotification } from '../../redux/actions/general/notification';
import CanvasEditor from '../../components/CanvasEditor/CanvasEditor';
import DownloadIcon from '../../assets/images/download-15x15.svg';
import RotateRightIcon from '../../assets/images/rotate-right-15x15.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import { leaveChannel, listenPlanProcessed } from '../../core/sockets';

const PlanVersionPreview = ({
  table: {
    annotations,
    pinned_tasks,
    data,
    clicked_row,
    showFilters,
    filters,
    flyout,
  },
  canvas_editor: { viewer, fabricOverlay },
  match,
  location,
  task_table,
  actions,
  localization,
  history,
  working_set_specifications,
}) => {
  const url_parameters = queryString.parse(history.location.search);

  const [planVersionData, setPlanVersionData] = useState(null);
  const [taskPreview, setTaskPreview] = useState(null);

  const [isPreparingSearch, setIsPreparingSearch] = useState(false);
  const [isRetilingTiles, setIsRetilingTiles] = useState(false);

  const prevTaskStatusRef = useRef();
  const prevClickedRowRef = useRef();

  const plan_version_id = match.params.plan_version;

  const refreshPlanVersionData = () =>
    readPlanVersion(plan_version_id).then(({ response }) => {
      setPlanVersionData(response.data);

      return response;
    });

  useEffect(() => {
    let stage_id;

    readPlanVersion(plan_version_id).then(({ response }) => {
      const plan_version_data = response.data;
      stage_id = plan_version_data.plan.stage_id;

      const params = queryString.parse(location.search);

      _.each(params, (value, key) => {
        //TODO - try to merge this with the upper keys using pickBy()
        if (_.startsWith(key, 'filter.')) {
          const params = {};
          params[key] = value;

          setTableParams('working_set_plans', params);
        }
      });

      listPinnedPlanVersionSpecifications(plan_version_id);

      listPlanVersionPlans(plan_version_id);

      listPlanVersionTasks(plan_version_id).then(({ response }) => {
        readPlanVersionAnotation(plan_version_id).then(({ response }) => {
          setPlanVersionData(plan_version_data);
        });
      });

      listActiveModules();

      readWorkingSetPlan(response.data.plan.id).then(({ response }) => {});

      listenPlanProcessed(stage_id, (plan_id) => {
        if (plan_id == plan_version_data.plan.id) {
          refreshPlanVersionData().then(() => {
            setIsRetilingTiles(false);
          });
        }
      });

      getPreferences(`working_set_plans.plan_version_preview`).then(
        ({ response: { data } }) => {
          const user_preference_params = _.transform(
            data,
            (params, value, key) => {
              if (_.startsWith(key, 'filter_')) {
                params[key.replace('filter_', 'filter.')] = _.toString(value);
              } else {
                params[key] = value;
              }
            },
            {}
          );

          setTableParams(
            'working_set_plans',
            _.pick(user_preference_params, [
              'disabled_columns',
              'pinned_columns',
              'view',
            ])
          );
        }
      );

      enableProjectsDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/working')
      );
      enableStagesDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/working')
      );

      const approval = _.get(
        queryString.parse(location.search),
        'approval',
        undefined
      );

      createSidebar({
        title: __('submenu.title.plans'),
        items: [
          {
            title: __('submenu.title.current-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/current',
          },
          {
            title: __('submenu.title.working-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/working',
            active: _.isUndefined(approval),
          },
          {
            title: __('submenu.title.uploads'),
            link: () => '/stages/' + getActiveStage() + '/plans/uploads',
          },
          {
            title: __('submenu.title.deliveries'),
            link: () => '/stages/' + getActiveStage() + '/deliveries',
          },
          {
            title: __('submenu.title.approvals'),
            link: () => '/stages/' + getActiveStage() + '/approvals',
            active: !_.isUndefined(approval),
            items: !_.isUndefined(approval) && [
              {
                title: __('submenu.title.approvals.pending'),
                link: () =>
                  '/stages/' + getActiveStage() + '/approvals/pending',
                active: approval == 'pending',
              },
              {
                title: __('submenu.title.approvals.approved'),
                link: () =>
                  '/stages/' + getActiveStage() + '/approvals/approved',
                active: approval == 'approved',
              },
              {
                title: __('submenu.title.approvals.rejected'),
                link: () =>
                  '/stages/' + getActiveStage() + '/approvals/rejected',
                active: approval == 'rejected',
              },
            ],
          },
        ],
      });
    });

    if (getURLParam('specification_id'))
      readWorkingSetSpecification(getURLParam('specification_id')).then(
        ({ response }) => {
          setTableParams('working_set_specifications', {
            clicked_row: response.data.id,
            flyout: response.data,
          });
        }
      );

    if (getURLParam('task_id'))
      readTask(getURLParam('task_id')).then(({ response }) => {
        setTableParams('all_tasks', {
          clicked_row: response.data.id,
        });
        setTaskPreview(response.data);
      });

    if (getURLParam('id'))
      actions.setTableParams({ clicked_row: getURLParam('id') });

    return () => {
      stage_id && leaveChannel('working_set_plans.' + stage_id);
      setPlanVersionData(null);
    };
  }, []);

  useEffect(() => {
    const clickedRow = task_table?.clicked_row;
    const prevClickedRow = prevClickedRowRef.current;

    if (clickedRow) {
      readTask(clickedRow).then(({ response }) => {
        prevTaskStatusRef.current = response.data.status;

        setTaskPreview(response.data);
      });
    }

    if (!clickedRow && clickedRow !== prevClickedRow) {
      setURLParam('task_id', '');
    }

    prevClickedRowRef.current = clickedRow;
  }, [task_table?.clicked_row]);

  useEffect(() => {
    const clickedRow = working_set_specifications?.clicked_row;
    const prevClickedRow = prevClickedRowRef.current;

    if (clickedRow) {
      readWorkingSetSpecification(clickedRow).then(({ response }) => {
        setTableParams('working_set_specifications', {
          flyout: response.data,
        });
      });
    }

    if (!clickedRow && clickedRow !== prevClickedRow) {
      setURLParam('specification_id', '');
    }

    prevClickedRowRef.current = clickedRow;
  }, [working_set_specifications?.clicked_row]);

  useEffect(() => {
    const prevClickedRow = prevClickedRowRef.current;

    if (!clicked_row && clicked_row !== prevClickedRow) {
      setURLParam('id', '');
    }

    prevClickedRowRef.current = clicked_row;
  }, [clicked_row]);

  useEffect(() => {
    const currentStatus = task_table?.flyout?.status;
    const prevStatus = prevTaskStatusRef.current;

    if (prevStatus !== undefined && currentStatus !== prevStatus) {
      if (task_table?.clicked_row && currentStatus) {
        const canvas = fabricOverlay.fabricCanvas();

        const taskObj = findTaskObjectOnCanvas(canvas, task_table?.clicked_row);

        if (taskObj) {
          const color = getStatusColor(currentStatus);
          taskObj.set({
            stroke: color,
            fill: color,
          });
          canvas.requestRenderAll();
        }
      }

      prevTaskStatusRef.current = currentStatus;
    }
  }, [task_table?.flyout?.status]);

  const handleSubmit = (fabricOverlay, refreshData = false) => {
    const canvas = fabricOverlay.fabricCanvas();
    const activeObject = canvas.getActiveObject();

    if (activeObject?.type === 'activeSelection') {
      activeObject.getObjects().forEach((child) => {
        child.setCoords();
      });
      canvas.discardActiveObject();
    }

    activeObject && resetObjectStyle(activeObject);

    const allObjects = canvas
      .getObjects()
      .filter(
        (obj) => !['controlpoint', 'arrow-head'].includes(obj.objectType)
      );

    const serializedObjects = {
      objects: allObjects.map((obj) =>
        obj.toObject([
          'objectType',
          'originalLeft',
          'originalTop',
          'taskID',
          'planID',
          'userID',
          'specificationCodeID',
          'lockMovementX',
          'lockMovementY',
          'userFullName',
          'objectCaching',
        ])
      ),
    };
    // const serializedObjects = {
    //   objects: {},
    // };
    activeObject && selectObjectStyle(activeObject);

    updatePlanVersionAnotation(
      plan_version_id,
      JSON.stringify(serializedObjects)
    ).then(() => {
      if (refreshData) {
        readPlanVersion(plan_version_id);

        readPlanVersionAnotation(plan_version_id).then(({ response }) => {
          //setPlanRevisionData(plan_revision_data);
        });
      }
    });
  };

  const _goBack = () => {
    // window.previousLocation
    //   ? window.history.back()
    //   : redirect('/stages/' + getActiveStage() + '/plans/working');

    redirect('/stages/' + getActiveStage() + '/plans/working');
  };

  const _toggleFilterFlyout = () => {
    setTableParams('working_set_plans', {
      showFilters: !showFilters,
    });

    setTableParams('all_tasks', {
      clicked_row: undefined,
    });
  };

  const _setURLParams = (params) => {
    const search = queryString.stringify({
      ...queryString.parse(location.search),
      ...params,
    });
    redirect({ search }, true);
  };

  const filtersSort = (filter, value, label) => {
    switch (filter) {
      case 'status':
        return sortValuesByArray(
          [
            'not-started',
            'started',
            'reopened',
            'finished',
            'closed',
            'canceled',
          ],
          value
        );
    }
  };

  const _toggleCompareTool = () => {
    const compare = _.get(
      queryString.parse(location.search),
      'compare',
      undefined
    );

    redirect(
      {
        search: queryString.stringify({
          ...queryString.parse(location.search),
          compare: compare ? undefined : '1',
        }),
      },
      true
    );
  };

  const handleNeighborClick = (plan_version_id) => {
    redirect('/plans/versions/' + plan_version_id);
  };

  const approval = _.get(
    queryString.parse(location.search),
    'approval',
    undefined
  );

  const handleParsePdf = () => {
    setIsPreparingSearch(true);

    return parsePlanPdfToJson(_.last(flyout.versions).id)
      .then(() => {
        return readWorkingSetPlan(flyout.id);
      })
      .then(() => {
        setNotification(
          __('plans.working-set.notification.pdf-to-json.parsing-started')
        );
      })
      .finally(() => {
        setIsPreparingSearch(false);
      });
  };

  const handleRetilePlanTiles = () => {
    if (isRetilingTiles) {
      return;
    }

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __('plans.retile.alert.description'),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('plans.retile.alert.confirm'),
          onClick: () => {
            setIsRetilingTiles(true);

            retilePlanVersion(plan_version_id)
              .then(() => {
                hideAlertbox();
                refreshPlanVersionData();

                setNotification(__('plans.retile.notification.queued'));
              })
              .catch(() => {
                setIsRetilingTiles(false);
              });
          },
        },
      ],
    });
  };

  let first_plan_id, last_plan_id, prev_plan_id, next_plan_id;

  if (!_.isEmpty(data) && planVersionData) {
    first_plan_id = _.first(data).last_version.id;
    last_plan_id = _.last(data).last_version.id;

    prev_plan_id =
      _.get(data, [
        _.findIndex(data, ['id', planVersionData.plan.id]) - 1,
        'last_version',
        'id',
      ]) || first_plan_id;
    next_plan_id =
      _.get(data, [
        _.findIndex(data, ['id', planVersionData.plan.id]) + 1,
        'last_version',
        'id',
      ]) || last_plan_id;
  }

  const RenderLeftTitleComponent = () => {
    return (
      <div className={styles.left}>
        <div className={styles.back} onClick={_goBack}>
          <Tooltip text={__('plans.tooltip.icon.back-to-list')}>
            <ArrowLeftMiddleIcon />
          </Tooltip>
        </div>

        <div className={styles.separator} />

        {_.isUndefined(approval) ? (
          <>
            <TitleBar
              title={__('submenu.title.working-set')}
              dropdownHeader={__('submenu.title.plans')}
              loading={false}
            />

            <ArrowRightSmallIcon />
            {planVersionData.plan.discipline.id == null
              ? planVersionData.plan.discipline.description + '*'
              : _.get(localization.disciplines, [
                  planVersionData.plan.discipline.id,
                  'name',
                ])}
          </>
        ) : (
          'Approvals'
        )}
        <ArrowRightSmallIcon />
        {_.filter(
          [planVersionData.plan.code, planVersionData.plan.title],
          _.identity
        ).join(': ')}
      </div>
    );
  };

  const can_compare = planVersionData && planVersionData?.versions > 1;
  const plan_has_tiles = !_.isEmpty(planVersionData?.plan?.tiles);

  const compare_has_tiles =
    planVersionData?.plan?.tiles_available !== false && plan_has_tiles;
  const can_retile_tiles = planVersionData?.can_retile && !compare_has_tiles;

  const compare =
    _.has(queryString.parse(location.search), 'compare') &&
    can_compare &&
    compare_has_tiles &&
    !isSafari;

  if (compare && url_parameters.compare === '1') {
    return (
      <ComparePlans
        name={'versions'}
        action={() => listComparablePlanVersions(plan_version_id)}
        onInfoIconClick={() => {
          actions.setTableParams({
            clicked_row: flyout.id,
          });

          setURLParam('id', flyout.id);

          setTableParams('all_tasks', {
            clicked_row: undefined,
          });
        }}
        planWidth={planVersionData.plan.width}
        planHeight={planVersionData.plan.height}
        leftTitleComponent={<RenderLeftTitleComponent />}
      />
    );
  }

  const neighbor_directions = [
    { key: 'left', tooltip: __('content.tooltip.table.left-child-plan') },
    { key: 'up', tooltip: __('content.tooltip.table.up-child-plan') },
    { key: 'right', tooltip: __('content.tooltip.table.right-child-plan') },
    { key: 'down', tooltip: __('content.tooltip.table.down-child-plan') },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        {planVersionData && (
          <div className={styles.title}>
            {/* Plan title - Left side */}
            <RenderLeftTitleComponent />

            {planVersionData && (
              <div className={styles.right}>
                <SearchInline
                  onSearch={(query) => {
                    return searchPdfTextPositions(plan_version_id, query);
                  }}
                  disabled={!flyout?.is_parsed_pdf_to_json}
                  onPrepareSearch={handleParsePdf}
                  loading={isPreparingSearch}
                />

                <div className={styles.separator} />

                <Tooltip
                  text={__('plans.tooltip.icon.working-set.download-version')}
                >
                  <DownloadIcon
                    onClick={() => {
                      actions.setTableParams({
                        export_plan_annotations_wizard: true,
                      });
                    }}
                  />
                </Tooltip>

                <div className={styles.separator} />

                {can_retile_tiles && (
                  <>
                    <Tooltip
                      text={
                        isRetilingTiles
                          ? __(
                              'plans.tooltip.icon.retile-plan-version-processing'
                            )
                          : __('plans.tooltip.icon.retile-plan-version')
                      }
                    >
                      <RotateRightIcon
                        className={classNames(
                          isRetilingTiles && styles.disabled
                        )}
                        onClick={handleRetilePlanTiles}
                      />
                    </Tooltip>
                    <div className={styles.separator} />
                  </>
                )}

                {can_compare && (isSafari || !compare_has_tiles) && (
                  <Tooltip
                    text={
                      isSafari
                        ? 'Compare tool is not available in Safari browser'
                        : __('plans.tooltip.icon.compare-disabled-no-tiles')
                    }
                  >
                    <CompareIcon
                      className={classNames(
                        compare && styles.active,
                        styles.disabled
                      )}
                    />
                  </Tooltip>
                )}
                {can_compare && compare_has_tiles && !isSafari && (
                  <Tooltip text={__('plans.tooltip.icon.plan-version-compare')}>
                    <CompareIcon
                      className={classNames(compare && styles.active)}
                      onClick={_toggleCompareTool}
                    />
                  </Tooltip>
                )}
                {can_compare && <div className={styles.separator} />}
                {!_.isEmpty(filters) && (
                  <>
                    <Tooltip text={__('plans.tooltip.icon.filters')}>
                      <FilterIcon
                        className={styles.filter}
                        onClick={_toggleFilterFlyout}
                      />
                    </Tooltip>
                  </>
                )}
                <div className={styles.separator} />
                <Tooltip text={__('plans.tooltip.icon.plan-properties')}>
                  <InfoPositiveIcon
                    className=''
                    onClick={() => {
                      actions.setTableParams({
                        clicked_row: flyout.id,
                      });

                      setURLParam('id', flyout.id);

                      setTableParams('all_tasks', {
                        clicked_row: undefined,
                      });
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Filter */}

      <Filter
        name={'working_set_plans'}
        //listAction={refreshData}
        setURLParams={(params) => _setURLParams(params)}
        filterData={filterPlanVersionAnnotations}
        filtersSort={filtersSort}
        source={'plan_version_preview'}
      />

      {/* Table */}
      {planVersionData && (
        <CanvasEditor
          annotations={annotations}
          onSubmit={handleSubmit}
          pinnedTasks={pinned_tasks}
          source={planVersionData?.plan}
          sourceType='plan'
        >
          <div className={styles.neighbors} id='neighbors'>
            {neighbor_directions.map(({ key, tooltip }) => (
              <Tooltip key={key} text={tooltip}>
                <ArrowDoubleLeftMiddleIcon
                  className={classNames(
                    styles[key],
                    flyout?.neighbors?.[key] && styles.active
                  )}
                  onClick={() => handleNeighborClick(flyout?.neighbors?.[key])}
                />
              </Tooltip>
            ))}
          </div>
        </CanvasEditor>
      )}

      {/* Footer */}

      {!_.isEmpty(data) && planVersionData && (
        <div className={styles.footer}>
          <div className={styles.pagination}>
            <Tooltip text={__('content.tooltip.table.first-page')}>
              <ArrowDoubleLeftMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + first_plan_id, true)
                }
              />
            </Tooltip>
            <Tooltip text={__('content.tooltip.table.prev-page')}>
              <ArrowLeftMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + prev_plan_id, true)
                }
              />
            </Tooltip>
            <span className={classNames(styles.page, styles.active)}>
              {planVersionData.plan.code}
            </span>
            <Tooltip text={__('content.tooltip.table.next-page')}>
              <ArrowRightMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + next_plan_id, true)
                }
              />
            </Tooltip>
            <Tooltip text={__('content.tooltip.table.last-page')}>
              <ArrowDoubleRightMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + last_plan_id, true)
                }
              />
            </Tooltip>
          </div>
        </div>
      )}

      {/* Flyout */}

      <div
        className={classNames(
          styles.flyout,
          (clicked_row ||
            task_table?.clicked_row ||
            working_set_specifications?.clicked_row) &&
            styles.active
        )}
      >
        {clicked_row && flyout && (
          <WorkingSetPlansFlyout
            data={flyout}
            readAction={(id) => {
              return new Promise((resolve) => {
                readWorkingSetPlan(planVersionData.plan.id).then(
                  ({ response }) => {
                    if (flyout.status == '1' && response.data.status == '0') {
                      readPlanVersion(match.params.plan_version).then(
                        ({ response }) => {
                          setPlanVersionData(response.data);

                          resolve(response);
                        }
                      );
                    }
                  }
                );
              });
            }}
          />
        )}
      </div>

      {task_table?.clicked_row &&
        taskPreview &&
        viewer &&
        ReactDOM.createPortal(
          <div
            style={{ top: 0 }}
            className={classNames(
              styles.flyout,
              (clicked_row || task_table?.clicked_row) && styles.active
            )}
          >
            <TasksFlyout
              data={taskPreview}
              readAction={(task_id) => {
                return new Promise((resolve) => {
                  readTask(task_id).then(({ response }) => {
                    setTaskPreview(response.data);

                    resolve(response);
                  });
                });
              }}
            />
          </div>,
          viewer.container
        )}

      {working_set_specifications?.clicked_row &&
        working_set_specifications?.flyout &&
        viewer &&
        ReactDOM.createPortal(
          <div
            style={{ top: 0 }}
            className={classNames(styles.flyout, styles.active)}
          >
            <WorkingSetSpecificationsFlyout
              data={working_set_specifications.flyout}
              readAction={(specification_id) => {
                return new Promise((resolve) => {
                  readWorkingSetSpecification(specification_id).then(
                    ({ response }) => {
                      setTableParams('working_set_specifications', {
                        flyout: response.data,
                      });

                      resolve(response);
                    }
                  );
                });
              }}
            />
          </div>,
          viewer.container
        )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    task_table: state.table['all_tasks'],
    table: state.table['working_set_plans'],
    working_set_specifications: state.table['working_set_specifications'],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.working_set_plans/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(PlanVersionPreview))
);
